import React, { useRef, useState } from "react";
import Heading from "@/components/Heading";
import { Form } from "@unform/web";
import * as Yup from "yup";
import Input from "@/components/Input";
import ModalPopup from "@/components/ModalPopup";
import { api } from "@/services/api";
import { useParams, useHistory } from "react-router-dom";

import "bootstrap/dist/css/bootstrap-grid.min.css";
import { Container } from "./styles";

export const RecoverPassword = () => {
	let history = useHistory();
	const { type } = useParams();
	const formRef = useRef(null);
	const [submit, setSubmot] = useState(false);
	const [modalPopup, setModalPopup] = useState(false);
	const [modalContent, setModalContent] = useState({
		title: "",
		content: "",
	});

	async function handleSubmit(data) {
		try {
			const schema = Yup.object().shape({
				email: Yup.string()
					.email("E-mail inválido")
					.required("Campo obrigatório"),
			});

			await schema.validate(data, {
				abortEarly: false,
			});

			handleRecover(data);
			formRef.current.setErrors({});
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errorMessages = {};

				err.inner.forEach((error) => {
					errorMessages[error.path] = error.message;
				});

				formRef.current.setErrors(errorMessages);
			}
		}
	}

	function handleRecover(data) {
		setSubmot(true);

		api.post(`${type}/recovery`, data)
			.then((res) => {
				setSubmot(false);

				if (res.data.status === 200) {
					setModalPopup(true);
					setModalContent({
						title: "Programa de Fidelidade",
						content: res.data.message,
					});
					
					setTimeout(() => {
						history.push(`${process.env.PUBLIC_URL}/`);
					}, [5000]);
				}

				if (res.data.status === 400) {
					setModalPopup(true);
					setModalContent({
						title: "Ocorreu um problema!",
						content: res.data.message,
					});
				}
			})
			.catch((error) => {
				setSubmot(false);
				setModalPopup(true);
				setModalContent({
					title: "Ocorreu um problema!",
					content: "Ops! Não foi possível atender sua solicitação.",
				});
				console.error({ endPoint: `/${type}/recovery`, error });
			});
	}

	return (
		<Container>
			<ModalPopup
				visible={modalPopup}
				message={modalContent}
				onClick={() => setModalPopup(!modalPopup)}
			/>

			<Heading>
				<p className='title'>
					<span>Esqueceu</span> sua senha?
				</p>
			</Heading>

			<div className='container-fluid'>
				<div className='row justify-content-lg-center'>
					<div className='col-12 col-lg-4'>
						<span className='separator'></span>
						<Form
							ref={formRef}
							name='recoverPassword'
							onSubmit={handleSubmit}
							className='content'>
							<p>
								Para relembrar sua senha, preencha o campo
								abaixo com seu <strong style={{ whiteSpace: "nowrap" }}>E-mail</strong> informado no cadastro. As
								instruções para alteração serão enviadas para ele.
							</p>

							<Input
								label='E-mail*'
								name='email'
								placeholder='user@mail.com'
							/>

							<button
								type='submit'
								className='btn-secundary'
								disabled={submit ? "disabled" : ""}>
								{submit ? "enviando" : "enviar"}
							</button>
						</Form>
					</div>
				</div>
			</div>
		</Container>
	);
};

export default RecoverPassword;
